import { useEffect, useState } from "react";
import { GetUserDetailsByRoleId } from "../../../services/userService";
import { useNavigate } from "react-router-dom";

const ListAdminStaff=()=>{
const navigate=useNavigate();
    const [userData, setUserData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const response = await GetUserDetailsByRoleId();
                const data = response.data;
                if (response.statusCode === 200 && response.success === true) {
                    setError("");
                    setUserData(data);
                }
                else {
    setError("something went wrong");
}
            } catch (error) {

    console.log(error);
    setError(error.message || "Something went wrong");
}finally {
            setLoading(false);
        }
        }

fetchData();
    }, []);
return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">User List</h4>
                </div>
                <div className="card-body">
                    {loading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <>
                         {/* Total Records */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">
                    Total Records: 
                    <span className="badge bg-primary ms-2">
                        {userData.length}
                    </span>
                </h5>
                 <button
        className="btn btn-success"
        onClick={() => navigate("/staffnew")}
    >
        + Add New User
    </button>
            </div>
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover align-middle">
                                <thead className="table-dark">
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Parent Name</th>
                                        <th>Mobile</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        <th>Status</th>
                                        <th>Action </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {userData.length > 0 ? (
                                        userData.map((user, index) => (
                                            <tr key={user.id}>
                                                <td>{index + 1}</td>
                                                <td>{user.userName}</td>
                                                <td>
                                                    {user.parentUserName || "-"}
                                                </td>
                                                <td>
                                                    {user.mobileNo}
                                                </td>
                                                <td>
                                                    {user.email}
                                                </td>
                                                <td>
                                                    {user.role}
                                                </td>
                                                <td>
                                                    <span
                                                        className={`badge ${
                                                            user.status ===
                                                            "Active"
                                                                ? "bg-success"
                                                                : "bg-danger"
                                                        }`}
                                                    >
                                                        {user.status}
                                                    </span>
                                                </td>
                                                <td>
    <button
        className="btn btn-warning btn-sm me-2"
        onClick={() => navigate(`/staffEdit/${user.id}`)}
    >
        Edit
    </button>
</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="4"
                                                className="text-center"
                                            >
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
export default ListAdminStaff;